import {
  formatDate as formatDateDef,
  formatDateOnly as formatDateOnlyDef,
  formatDateTimeMysql as formatDateTimeMysqlDef
} from "./date";
import {
  formatClient as formatClientDef,
  formatEoc as formatEocDef
} from "./episodeOfCare";
import { formatUser as formatUserDef } from "./user";

function evalWrapper(expression, callbacks) {
  "use strict";
  // eslint-disable-next-line no-unused-vars
  const formatDate = formatDateDef;
  // eslint-disable-next-line no-unused-vars
  const formatDateOnly = formatDateOnlyDef;
  // eslint-disable-next-line no-unused-vars
  const formatDateTimeMysql = formatDateTimeMysqlDef;
  // eslint-disable-next-line no-unused-vars
  const formatClient = formatClientDef;
  // eslint-disable-next-line no-unused-vars
  const formatEoc = formatEocDef;
  // eslint-disable-next-line no-unused-vars
  const formatUser = formatUserDef;
  // eslint-disable-next-line no-unused-vars
  const setComponentValue = callbacks["setComponentValue"];
  return eval(expression);
}

export const computeExpression = (
  expression,
  statements = false,
  callbacks = {}
) => {
  try {
    const result = evalWrapper(expression, callbacks);
    if (typeof result != "undefined") {
      if (statements) return result;
      return JSON.parse(result);
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};
